import React, { useState } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import SignUp from '../Pages/Signup/Signup';
import Details from '../Pages/Details';
import ProtectedRoutes from '../protected-routes/Protected-routes';
import Home from '../Pages/Menu/Home';
import Profile from '../Pages/Profile/Profile';
import PaymentHandler from '../Pages/PaymentHandler/PaymentHandler';
import ConfirmOrderPage from '../Pages/CheckoutPage/ConfirmOrderPage';
import Menu from '../Pages/Menu/Menu';
import { useEffect } from 'react';
import { Licenses } from '../Pages/licences/licenses';
import { useDispatch, useSelector } from 'react-redux';
import MenuItems from '../Pages/Menu/Menu-items';
import { environment } from '../../environments/environment';
import { firestore } from '../../../../../libs/firebase-service/src';
import ContactUs from '../Pages/Contactus/contactus';
import Careers from '../Pages/Contactus/careers';
import { createBrowserHistory } from 'history';
import ScrollToTop from './ScrollTop';
import Aboutus from '../Pages/Aboutus/aboutus';
import PrivacyPolicy from '../Pages/PP-terms/PrivacyPolicy';
import TermsConditions from '../Pages/PP-terms/termsConditions';
// import { useTranslation } from 'react-i18next';
import MenuItems2 from '../Pages/Menu/Menu-items2';
import Sitemap from '../Pages/Sitemap/sitemap';
import Blogs from '../Pages/Blogs/blogs';
import BlogDetails from '../Pages/Blogs/blogDetails';
import Cart from '../Pages/Cart/Cart';
import PageNotFound from '../Pages/NotFound/PageNotFound';
import OrderSuccess from '../Pages/CheckoutPage/OrderSuccess';

// DoorDash Redirect Component
const DoorDashRedirect = () => {
  useEffect(() => {
    const doorDashUrl = "https://www.doordash.com/store/taqwa%27s-bakery-&-restaurant-greenfield-1215969/1774444/?srsltid=ARcRdnpeF0c1veDKXV9u0niPvm4FDCyOPAJ2AaV3Roz4pyvQ22aqm3al";
    window.location.href = doorDashUrl;
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: '"Jost", sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <h2>Redirecting to DoorDash...</h2>
        <p>You will be redirected to our DoorDash page shortly.</p>
        <p>If you are not redirected automatically, <a href="https://www.doordash.com/store/taqwa%27s-bakery-&-restaurant-greenfield-1215969/1774444/?srsltid=ARcRdnpeF0c1veDKXV9u0niPvm4FDCyOPAJ2AaV3Roz4pyvQ22aqm3al" style={{ color: '#ff6b35' }}>click here</a>.</p>
      </div>
    </div>
  );
};

const Navigation = () => {
  const licenses = useSelector((state) => state.licenReducer.licenses);
  const location = useLocation(); 
  const navigate = useNavigate();
  const check = window.localStorage.getItem('items');
 
  useEffect(() => {
    
    if (location.pathname.startsWith('/profile')) {
   
      const cleanUrl = location.pathname.split('?')[0];
  
      
      if (location.pathname !== cleanUrl) {
       
        window.history.replaceState(
          null,
          '',
          `${window.location.origin}${cleanUrl}`
        );
  
        
        window.location.href = cleanUrl;  
      }
    }
  }, [location.pathname, navigate]);  
  
  useEffect(() => {
    
    const pageTitle =
      environment.restaurantId === 'istanbulDk'
        ? `${'IstanbulDk'}`
        : environment.restaurantId === 'alyousef'
        ? 'alyousef'
        : environment.restaurantId === 'filfil'
        ? 'Filfil'
        : environment.restaurantId === 'istanbulDk' || environment.restaurantId === 'taqwasbakery' 
        ? 'TaqwasBakery'
        : environment.restaurantId === 'elmbrookschools'
        ? 'Elmbrookschools'
        : 'Table Tuck';
    document.title = pageTitle;
  }, []);

  const checkLicenses = (pageName) => {
    switch (pageName) {
      case 'checkout':
        return licenses.frontend.checkout;
      case 'signup':
        return check != 'true' ? licenses.frontend.signup : false;
      case 'home':
        return check != 'true' ? licenses.frontend.home : true;
      case 'details':
        return check != 'true' ? licenses.frontend.details : true;
      case 'profile':
        return check != 'true' ? licenses.frontend.checkout : false;
      case 'basket':
        return check != 'true' ? licenses.frontend.basket : false;
      case 'menu':
        return check != 'true' ? licenses.frontend.menu : true;

      default:
        return false;
    }
  };

  if (!licenses) {
    return <> </>;
  }
  // const [t, i18n] = useTranslation();

  return (
    <div>
      <ScrollToTop />
      <Routes>
      
      <Route path="/" element={checkLicenses('home') ? <DoorDashRedirect /> : <Licenses />} />
        <Route
          path="/signup"
          element={checkLicenses('signup') ? <SignUp /> : <Licenses />}
        />

      
         <Route
          path="/blogs"
          element={checkLicenses('home') ? <Blogs /> : <Licenses />}
        />
       

        <Route
 path="/blogs/:id"
           element={checkLicenses('home') ?  <BlogDetails /> : <Licenses />}
        />
        {/* <Route
          path="/menu/:id"
          element={checkLicenses('menu') ? <Menu /> : <Licenses />}
        /> */}
        <Route
          path="/menu-items"
          element={checkLicenses('menu') ? <MenuItems /> : <Licenses />}
        />
        <Route
          path="/menu-items/:id"
          element={checkLicenses('menu') ? <MenuItems /> : <Licenses />}
        />
         <Route
          path="/cart"
          element={checkLicenses('basket') ? <Cart /> : <Licenses />}
        />
        <Route
          path="/menu/:id"
          element={checkLicenses('menu') ? <MenuItems2 /> : <Licenses />}
        />
        <Route
          path="/details/:id"
          element={checkLicenses('details') ? <Details /> : <Licenses />}
        />
          <Route path="/sitemap.xml" element={<Sitemap />} />
         
        <Route element={<ProtectedRoutes />}>
          <Route
            path="/profile/*"
            element={checkLicenses('profile') ? <Profile /> : <Licenses />}
          />
          <Route
            path="/payment"
            element={
              checkLicenses('checkout') ? <PaymentHandler /> : <Licenses />
            }
          />

          <Route path="/confirmorder" element={<ConfirmOrderPage />} />
          <Route path="/ordersuccess" element={<OrderSuccess />} />
          

        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </div>
  );
};

export default Navigation;
